import {needAuth, noAuh} from "../../../api/instance/Instance";
import {AxiosError} from "axios";

async function getDepartments() {
    try{
        // return await noAuh.get('/departments');
        return await needAuth.get('/departments');
    }catch (error){
        return error;
    }
}

const selectDepartmentFlatListBySearch = async (search) => {
    try {
        return await needAuth.post('/departments', search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

async function saveDepartment(data) {
    try {
        return await needAuth.post(`/departments/create`, data);
    } catch (error) {
        if(error.response.data.resultCode === 'ERROR') {
            return error.response;
        }
    }
}

async function deleteDepartment(departmentId) {
    try {
        return await needAuth.delete(`/departments/${departmentId}`)
    } catch (error) {
        if(error.response.data.resultCode === 'ERROR') {
            return error.response;
        }
    }
}

async function updateDepartment(data) {
    try {
        return await needAuth.put(`/departments/`+data.id , data)
    } catch (error) {
        if(error.response.data.resultCode === 'ERROR') {
            return error.response;
        }
    }
}

export {
    getDepartments,
    selectDepartmentFlatListBySearch,
    saveDepartment,
    deleteDepartment,
    updateDepartment
};